import { request } from '../../services/RestClient';
import ServiceUrl from '../../utils/ServiceUrl';

export default class UserService {
  static async clearNothsSession() {
    return request({
      method: 'get',
      url: `${ServiceUrl.public('noths')}/session/destroy/frontend`,
      withCredentials: true,
    });
  }
}
